import styled from "styled-components";

export const InfoWrap = styled.div`
    height: calc(70vh - 32px);
    padding: 16px;
    display: flex;
    flex-direction: column;
    position: relative;

    .doc-panel{
        overflow: auto;
        padding-top: 16px;
        padding-bottom: 80px;
    }

    .btn-container{
        position: absolute;
        bottom: 0;
        right: 0;
        background-color: #FFF;
        padding: 20px;
        border-radius: 8px;
    }
    .ant-picker-disabled {
        .ant-picker-suffix{
            display: none;
        }
    }
`